import { EventDispatcher, addZero, gebi, getNodeIndex, getOffset, getTimeText, hideElement, isMobileView, l, lc, logEvent, lreplace, popStateCallback, qs, qsa, storedItemCreate, storedItemDelete, storedItemRead, toaster } from '@utils/toolbox';
import { eventCategories, events } from '@js/utils/event';
import checktick from '@/assets/images/global/checkbox.svg';
import { dateFormat } from '@utils/dateFns';
import noUiSlider from 'nouislider';
import { resultsRender } from '@components/resultsRender';
import { trackEvent } from '@utils/googleDataLayer';

export class Filters {
	constructor (config) {
		this.html = config.html;
		this._data = config.data;
		this._filtered = {};
		this._events = {};
		this._callbacks = config.callbacks || {};
		this._freezeSliders = false;
		this._sliderTimer = null;
		this._isYouthSearch = js_params?.isYouthSearch;
		this.popStateHelper = popStateCallback(this.hide.bind(this));

		this.set();
		this.initEvents();
	}

	render (filtersHTML) {
		const html = this.html;
		const data = this._data;
		const filtered = this._filtered;

		// Mobile navigation
		this.renderFilterNavBtns(filtered);

		// Apply filters aka load filters button
		qs('input#load-filters', html).checked = filtersHTML.savedFilters ? true : false;

		// Price slider
		this.renderPriceSlider(filtered.price || false);

		// Traveltime per trip slider
		let traveltimeSlideDefault = data.uniqueMaxTraveltimePerTrip.length - 1;
		// let traveltimeSlideText = data.uniqueMaxTraveltimePerTrip[traveltimeSlideDefault] || 1;
		let traveltimeSlideClosestKey = traveltimeSlideDefault;

		if (filtered.traveltime) {
			traveltimeSlideDefault = filtered.traveltime;
			// traveltimeSlideText = filtered.traveltime;
			traveltimeSlideClosestKey = this.findClosestSliderKey(data.uniqueMaxTraveltimePerTrip, traveltimeSlideDefault);
		}

		if (data.uniqueMaxTraveltimePerTrip.length > 0) {
			const sliderTravelTime = qs('#slider-traveltime', html);
			const sliderTravelTimeText = qs('#slider-traveltime-text', html);

			const travelTimeSlide = (values, handle) => {
				const value = Math.round(values[0], 10);
				const time = (data.uniqueMaxTraveltimePerTrip.length === 1) ? data.uniqueMaxTraveltimePerTrip[0] : data.uniqueMaxTraveltimePerTrip[value];

				sliderTravelTimeText.innerHTML = getTimeText(time);
			};

			if (sliderTravelTime.noUiSlider) {
				sliderTravelTime.noUiSlider.destroy();
			}

			noUiSlider.create(sliderTravelTime,
				{
					start: [traveltimeSlideClosestKey],
					connect: [true, false],
					range: {
						min: 0,
						max: data.uniqueMaxTraveltimePerTrip.length - 1 || 1
					},
					handleAttributes: [
						{ 'aria-label': `Min ${l('showresult.filter.travelTime')}` }
					]
				});

			sliderTravelTime.noUiSlider.on('update', travelTimeSlide);
			sliderTravelTime.noUiSlider.on('change', () => this.sliderChange(sliderTravelTime));

			travelTimeSlide([traveltimeSlideClosestKey], 0);
		}

		// Timetable sliders

		const timetables = qs('.timetables', html);

		timetables.querySelectorAll('.filter-slider').forEach((slider) => {
			if (slider.noUiSlider) {
				slider.noUiSlider.destroy();
			}
		});

		timetables.innerHTML = '';

		if (filtersHTML.timetables && filtersHTML.timetables.length) {
			for (let i = 0; i < filtersHTML.timetables.length; i++) {
				const { morningTimes, afternoonTimes, eveningTimes } = this.getUniqueDepartTimes(i);

				const enabledBtns = {
					morning: true,
					afternoon: true,
					evening: true
				};

				let disabledCount = 0;

				if (morningTimes.length <= 1) {
					enabledBtns.morning = false;
					disabledCount++;
				}

				if (afternoonTimes.length <= 1) {
					enabledBtns.afternoon = false;
					disabledCount++;
				}

				if (eveningTimes.length <= 1) {
					enabledBtns.evening = false;
					disabledCount++;
				}

				if (disabledCount === 2) {
					enabledBtns.morning = false;
					enabledBtns.afternoon = false;
					enabledBtns.evening = false;
				}

				timetables.insertAdjacentHTML('beforeend', this.buildTimetableHTML(i, filtersHTML.timetables[i], enabledBtns));
			}

			if (this._data.uniqueTimesOffset) {
				for (let i = data.uniqueTimesOffset.length - 1; i >= 0; --i) {
					this.createTimeFilter(i, data.uniqueTimesOffset[i], filtersHTML);
				}
			}

			if (this._data.uniqueWaittime) {
				this.createWaitingTimeSlider();
			}
		}

		const isDirectFlightsAvailable = data.uniqueNumStops.includes(0);
		const isOnlyDirectFlightsAvailable = isDirectFlightsAvailable && data.uniqueNumStops.length === 1;

		if (isOnlyDirectFlightsAvailable) { // If only direct flights are available hide the transfers section
			const transfersNavButton = hideElement('div.filtersNavBtn[data-show="transfers"]');
			const transfersView = hideElement('div#filter-transfers-section');

			if (transfersNavButton.classList.contains('filtersNavBtn--active')) {
				transfersNavButton.classList.remove('filtersNavBtn--active');
				transfersNavButton.nextElementSibling.classList.add('filtersNavBtn--active');
			}

			if (transfersView.classList.contains('filtersView--visible')) {
				transfersView.classList.remove('filtersView--visible');
				transfersView.nextElementSibling.classList.add('filtersView--visible');
			}
		} else if (!isDirectFlightsAvailable && !data.uniqueNumStops.includes(1)) { // If no direct flights and no max one stop flights hide the stops section
			hideElement(qs('div#stops-filters', this.html).parentElement);
		} else { // Hide individual buttons based on availability
			for (let i = 0; i < 2; i++) {
				if (!data.uniqueNumStops.includes(i)) {
					hideElement(qs(`#stops_${i}`, this.html).parentElement);
				}
			}
		}

		if (filtersHTML.numStops) {
			qs(`#stops_${ filtersHTML.numStops }`, html).checked = true;
		}

		if (filtersHTML.climateCompensated) {
			qs('#show-climate-compensation', html).checked = true;
		}

		qs('#hide-foreign', html).checked = ('foreign' in filtersHTML) ? (filtersHTML.foreign) : false;

		// if (filtersHTML.rebookableFlights)
		// {
		// 	qs('#show-rebookable', html).checked = true;
		// }

		if (filtersHTML.changesAirport) {
			qs('#hide-changes-airport', html).checked = true;
		}

		if (filtersHTML.blacklisted) {
			qs('#hide-blacklisted', html).checked = true;
		}

		if (filtersHTML.completePriceEnabled) {
			qs('#completePriceEnabled', html).classList.remove('hidden');
		}

		if (filtersHTML.flexTicket) {
			qs('#show-flex-ticket', html).checked = true;
		}

		if (this._isYouthSearch) {
			if (filtersHTML.youthTicket) {
				qs('#show-youth-ticket', html).checked = true;
			}
		}

		if (filtersHTML.baggageIncluded) {
			// TODO: future release...
			//
			// this.html.querySelector('#filtersBaggageInc').classList.add('filtersBaggageInc--visible');
			//
			// if (typeof params['filtersBaggagePerPerson'] !== 'undefined')
			// {
			// 	this.html.querySelector('#filtersBaggagePerPersonRadio').checked = true;
			// 	this.html.querySelector('#filtersBaggagePerPersonBtns').dataset.value = params['filtersBaggagePerPerson'];
			// 	this.html.querySelector('#filtersBaggagePerPerson').textContent = params['filtersBaggagePerPerson'];
			// }
			// else if (typeof params['filtersBaggageTotal'] !== 'undefined')
			// {
			// 	this.html.querySelector('#filtersBaggageTotalRadio').checked = true;
			// 	this.html.querySelector('#filtersBaggageTotalBtns').dataset.value = params['filtersBaggageTotal'];
			// 	this.html.querySelector('#filtersBaggageTotal').textContent = params['filtersBaggageTotal'];
			// }
			qs('#show-baggage-included', html).checked = true;
		}

		if (filtersHTML.cabinBaggageIncluded) {
			html.querySelector('#show-cabin-baggage-included').checked = true;
		}

		if (filtersHTML.paymentMethodIncluded) {
			const select = qs('#filter-paymentmethod-select', html);

			select.innerHTML = '';

			for (const paymentMethod of filtersHTML.paymentMethodIncluded) {
				const opt = document.createElement('option');

				opt.value = paymentMethod.value;
				opt.innerHTML = paymentMethod.name;

				if (paymentMethod.selected) {
					opt.setAttribute('selected', true);
				}

				select.appendChild(opt);
			}
		}

		if (filtersHTML.hasWaitTime) {
			const waitTime = qs('#hasWaitTime', html);

			waitTime.classList.remove('hidden');

			if (filtersHTML.airportWaitTime && data.uniqueWaittime.length > 0) {
				waitTime.querySelector('input').checked = true;
			}
		}

		const setSlider = (type, index, start, end) => {
			const arr = data.uniqueTimesOffset[index][type];

			const sliderType = (type === 'departures') ? 'departure' : 'arrival';
			const handle1 = this.findClosestSliderKey(arr, start);
			const handle2 = this.findClosestSliderKey(arr, end);

			const slider = qs(`#slider-timetable-${sliderType}-${index}`, html);

			slider.noUiSlider.set([handle1, handle2]);
		};

		if (filtersHTML.arrivalTime) {
			filtersHTML.arrivalTime.forEach((arrivalTime) => {
				const { tripIndex, start, end } = arrivalTime;
				setSlider('arrivals', tripIndex, start, end);
			});
		}

		if (filtersHTML.departureTime) {
			filtersHTML.departureTime.forEach((departureTime, index) => {
				let hasActiveTimetableBtn = false;
				let activeTimetableBtns = null;

				if (filtersHTML.activeTimetableBtns) {
					activeTimetableBtns = filtersHTML.activeTimetableBtns;

					if (typeof activeTimetableBtns[index] !== 'undefined') {
						if (activeTimetableBtns[index].timetableIndex === index) {
							hasActiveTimetableBtn = true;
						}
					}
				}

				if (hasActiveTimetableBtn) {
					const timetable = activeTimetableBtns[index];
					const { timetableIndex, btnIndex } = timetable;
					const btn = qs(`.filtersTimetable--${timetableIndex} button[data-index="${btnIndex}"]`, html);

					btn.classList.add('filtersTimetableBtns__btn--active');
				} else {
					const { tripIndex, start, end } = departureTime;
					setSlider('departures', tripIndex, start, end);
				}
			});
		}

		if (filtered.traveltime) {
			const slideClosestKey = this.findClosestSliderKey(data.uniqueMaxTraveltimePerTrip, filtered.traveltime);
			const sliderTravelTime = qs('#slider-traveltime', html);
			const sliderTravelTimeText = qs('#slider-traveltime-text', html);

			sliderTravelTime.noUiSlider.set(slideClosestKey);
			sliderTravelTimeText.textContent = getTimeText(filtered.traveltime);
		}

		if (filtersHTML.alliances.length) {
			qs('.alliances', html).classList.remove('hidden');

			let str = '';

			for (let i = 0; i < filtersHTML.alliances.length; i++) {
				const alliance = filtersHTML.alliances[i];

				str += `
<li>
	<label for="${alliance.id}" class="checkbox tabindex="0">
		<input id="${alliance.id}"
		type="checkbox"
		tabindex="-1"
		aria-label="${lreplace('ariaLabels.filterBy', { s: alliance.alliance })}"
		value="${alliance.value}" 
		${alliance.checked ? 'checked="checked"' : ''}>
		<div class="checkbox__tick">
			<div class="checkbox__tick--svg">${checktick}</div>
			<span>${alliance.alliance}</span>
		</div>
	</label>
</li>
				`;
			}

			qs('#filter-alliances .filtersList', html).innerHTML = str;
		}

		if (filtersHTML.enabledAirlines.length) {
			let str = '';
			let toggleEnabled = true;

			for (let i = 0; i < filtersHTML.enabledAirlines.length; i++) {
				const airline = filtersHTML.enabledAirlines[i];

				if (!airline.selected) {
					toggleEnabled = false;
				}

				str += `
<li>
	<label for="${airline.id}" class="checkbox" tabindex="0">
		<input id="${airline.id}"
		type="checkbox"
		${airline.selected ? `checked="checked"` : ``}
		aria-label="${lreplace('ariaLabels.filterBy', { s: airline.airline })}"
		tabindex="-1"
		value="${airline.value}">
		<div class="checkbox__tick">
			<div class="checkbox__tick--svg">${checktick}</div>
			<span>${airline.airline}</span>
		</div>
	</label>
	${this.generateExclusiveButton()}
</li>
				`;
			}

			qs('#filter-airlines', html).innerHTML = str;
			qs('#filter-airlines-toggle', html).checked = toggleEnabled;
		}

		if (filtersHTML.airportsDeparture.length) {
			const elem = qs('#filter-airports-departures', html);

			elem.innerHTML = this.buildAirportHTML(filtersHTML.airportsDeparture);
		}

		if (filtersHTML.airportsArrival.length) {
			const elem = qs('#filter-airports-arrivals', html);

			elem.innerHTML = this.buildAirportHTML(filtersHTML.airportsArrival);
		}

		if (filtersHTML.countryAirports.length) {
			let str = '';

			for (let i = 0; i < filtersHTML.countryAirports.length; i++) {
				const country = filtersHTML.countryAirports[i];

				str += `<li>
<label for="${country.id}" class="checkbox" tabindex="0">
	<input id="${country.id}" type="checkbox" 
	value="${country.value}" 
	data-type="country" 
	tabindex="-1"
	${country.selected ? `checked="checked"` : ``}
	aria-label="${lreplace('ariaLabels.filterBy', { s: country.country })}" >
	<div class="checkbox__tick">
		<div class="checkbox__tick--svg">${checktick}</div>
		<span>${country.country}</span>
	</div>
</label>
${this.generateExclusiveButton()}
				`;

				if (country.cities.length) {
					str += `<ul class="filtersList filtersList--inner">`;

					for (let k = 0; k < country.cities.length; k++) {
						const city = country.cities[k];

						str += `
<li>
	<label for="${city.id}" class="checkbox" tabindex="0">
		<input id="${city.id}"
		type="checkbox"
		value="${city.value}"
		data-type="city"
		tabindex="-1"
		${city.selected ? `checked="checked"` : ``}
		aria-label="${lreplace('ariaLabels.filterBy', { s: city.city })}" >
		<div class="checkbox__tick">
			<div class="checkbox__tick--svg">${checktick}</div>
			<span class="iata">${city.city}, ${city.iata}</span>
		</div>
	</label>
	${this.generateExclusiveButton()}
</li>
						`;
					}

					str += `</ul>`;
				}
				str += `</li>`;
			}


			qs('#filter-airports-section section:last-child', html).classList.remove('hidden');
			qs('#filter-stops', html).innerHTML = str;
		}

		if (filtersHTML.travelAgencies.length) {
			let str = ``;
			let toggleEnabled = true;

			for (let i = 0; i < filtersHTML.travelAgencies.length; i++) {
				const agency = filtersHTML.travelAgencies[i];

				if (!agency.selected) {
					toggleEnabled = false;
				}

				str += `
<li>
	<label for="${agency.id}" class="checkbox" tabindex="0">
		<input id="${agency.id}"
		type="checkbox"
		tabindex="-1"
		${agency.selected ? `checked="checked"` : ``}
		value="${agency.agencyValue}"
		arial-label="${lreplace('ariaLabels.filterBy', { s: agency.agencyName })}" >
		<div class="checkbox__tick">
			<div class="checkbox__tick--svg">${checktick}</div>
			<span>${agency.agencyName}</span>
		</div>
	</label>
	${this.generateExclusiveButton()}
</li>
				`;
			}

			qs('#filter-agencies-options', html).innerHTML = str;
			qs('#filter-agencies-toggle', html).checked = toggleEnabled;
		}

		qs('#sort-emission', html).checked = ('sortEmission' in filtersHTML) ? filtersHTML.sortEmission : false;


		// Collapse filters

		if (storedItemRead('savedFilters')) {
			const savedFilters = storedItemRead('savedFilters');

			if (savedFilters.hasOwnProperty('collapsed')) {
				if (savedFilters.collapsed.length) {
					savedFilters.collapsed.forEach((section) => {
						const filterView = qs(`#${section}`, html);

						if (filterView) {
							filterView.classList.add('filtersView--collapsed');
						}
					});
				}
			}
		}

		if (this._callbacks.onRender) {
			this._callbacks.onRender();
		}
	}

	renderFilterNavBtns (filtered) {
		const filteredCategories = Object.keys(filtered);
		const filterBtns = qsa('.filtersNav .filtersNavBtn', this.html);
		const filteredMappings = {
			transfers: ['changesAirport', 'numStops', 'airportWaitTime'],
			durations: ['traveltime', 'departureTime', 'arrivalTime'],
			prices: ['price', 'paymentMethods', 'paymentMethodIncluded', 'flexTicket', 'baggageIncluded', 'cabinBaggageIncluded', 'climateCompensated'],
			airlines: ['enabledArlines', 'blacklisted'],
			airports: ['airportStops'],
			agencies: ['enabledAgents', 'foreign'],
			sortings: ['sortEmission']
		};

		if (this._isYouthSearch) {
			filteredMappings.prices.push('youthTicket');
		}

		filterBtns.forEach(button => button.classList.remove('filtersNavBtn--set'));

		for (const category in filteredMappings) {
			const subFilters = filteredMappings[category];

			subFilters.forEach((subFilter) => {
				filteredCategories.forEach((currFilter) => {
					if (subFilter === currFilter) {
						filterBtns.forEach((button) => {
							if (button.dataset.show === category) {
								button.classList.add('filtersNavBtn--set');
							}
						});
					}
				});
			});
		}
	}

	renderFilterSummaries (filtered) {
		const html = this.html;
		const summaries = {
			transfers: [],
			durations: [],
			prices: [],
			airlines: [],
			airports: [],
			agencies: [],
			sortings: []
		};

		// Transfers

		if (filtered.hasOwnProperty('numStops')) {
			const stops = parseInt(filtered.numStops, 10);
			const texts = [
				l('showresult.filter.summary.directFlightsOnly'),
				l('showresult.filter.summary.maxOneStop')
			];

			summaries.transfers.push(texts[stops]);
		}

		if (filtered.hasOwnProperty('changesAirport')) {
			summaries.transfers.push(l('showresult.filter.summary.noChangeOfAirport'));
		}

		if (filtered.hasOwnProperty('airportWaitTime')) {
			summaries.transfers.push(l('showresult.filter.summary.excludeLongTransferTime'));
		}

		// Durations

		if (filtered.hasOwnProperty('traveltime')) {
			const traveltime = getTimeText(filtered.traveltime);

			summaries.durations.push(lreplace('showresult.filter.summary.maxTraveltimePerTrip', { time: traveltime }));
		}

		if (filtered.hasOwnProperty('departureTime')) {
			// TODO: loop through filtered departure times and display them...

			summaries.durations.push(l('showresult.filter.summary.customDepartureTimes'));
		}

		if (filtered.hasOwnProperty('arrivalTime')) {
			// TODO: loop through filtered arrival times and display them...

			summaries.durations.push(l('showresult.filter.summary.customArrivalTime'));
		}

		// Prices

		if (filtered.hasOwnProperty('price')) {
			summaries.prices.push(lreplace('showresult.filter.summary.totalPrice', { lc: lc(filtered.price) }));
		}

		if (filtered.hasOwnProperty('flexTicket')) {
			summaries.prices.push(lreplace('showresult.filter.summary.flexTicket', { included: '<span>' + l('global.simplePhrases.included') + '</span>' }));
		}

		if (this._isYouthSearch) {
			if (filtered.hasOwnProperty('youthTicket')) {
				summaries.prices.push(lreplace('showresult.filter.summary.youthTicket', { included: '<span>' + l('global.simplePhrases.included') + '</span>' }));
			}
		}

		if (filtered.hasOwnProperty('baggageIncluded')) {
			summaries.prices.push(lreplace('showresult.filter.summary.baggageIncluded', { included: '<span>' + l('global.simplePhrases.included') + '</span>' }));
		}

		if (filtered.hasOwnProperty('cabinBaggageIncluded')) {
			summaries.prices.push(lreplace('showresult.filter.summary.cabinBaggageIncluded', { included: '<span>' + l('global.simplePhrases.included') + '</span>' }));
		}

		if (filtered.hasOwnProperty('rebookableFlights')) {
			summaries.prices.push(lreplace('showresult.filter.summary.rebookableIncluded', { included: '<span>' + l('global.simplePhrases.included') + '</span>' }));
		}

		if (filtered.hasOwnProperty('climateCompensated')) {
			summaries.prices.push(lreplace('showresult.filter.summary.carbonOffsetIncluded', { included: '<span>' + l('global.simplePhrases.included') + '</span>' }));
		}

		if (filtered.hasOwnProperty('paymentMethodIncluded')) {
			const cardType = js_params.module.Filters.paymentMethodsAll[filtered.paymentMethodIncluded];

			summaries.prices.push(lreplace('showresult.filter.summary.paymentWith', { card: cardType }));
		}

		// Airlines

		if (filtered.hasOwnProperty('blacklisted')) {
			summaries.agencies.push(l('showresult.filter.summary.hideBlacklistedTravelAgencies'));
		}

		if (filtered.hasOwnProperty('airlines')) {
			const airlines = filtered.airlines;

			let airlinesStr = '';
			const airlinesArr = [];

			airlines.forEach(airline => airlinesArr.push(resultsRender.response.airlineDetails[airline]));
			airlinesStr = airlinesArr.join(', ').trim();

			summaries.airlines.push(lreplace('showresult.filter.summary.excludeAirlines', { airlines: airlinesStr }));
		}

		// Airports

		const getAirportList = (filtered, transfers = false) => {
			const airportsArr = [];

			filtered.forEach((airport) => {
				if (!resultsRender.response.airportDetails[airport]) {
					return;
				}

				const airportData = resultsRender.response.airportDetails[airport];

				if (transfers) {
					airportsArr.push(airportData.city);
				} else {
					airportsArr.push(`${airportData.city} - ${airportData.airport}`);
				}
			});

			return airportsArr.join(', ').trim();
		};

		if (filtered.hasOwnProperty('airportArrivals')) {
			const arrivals = getAirportList(filtered.airportArrivals);

			summaries.airports.push(lreplace('showresult.filter.summary.excludeAirportLeave', { airports: arrivals }));
		}

		if (filtered.hasOwnProperty('airportDepartures')) {
			const departures = getAirportList(filtered.airportDepartures);

			summaries.airports.push(lreplace('showresult.filter.summary.excludeAirportReturn', { airports: departures }));
		}

		if (filtered.hasOwnProperty('airportStops')) {
			const transfers = getAirportList(filtered.airportStops, true);

			summaries.airports.push(lreplace('showresult.filter.summary.excludeAirportTransfer', { airports: transfers }));
		}

		// Agencies

		if (filtered.hasOwnProperty('foreign')) {
			summaries.agencies.push(l('showresult.filter.summary.onlyShowLocalTravelAgencies'));
		}

		if (filtered.hasOwnProperty('enabledAgents')) {
			const enabledAgents = filtered.enabledAgents;

			let agenciesStr = '';
			const agenciesArr = [];

			enabledAgents.forEach(agency => agenciesArr.push(js_params.module.Filters.agencies[agency]));
			agenciesStr = agenciesArr.join(', ').trim();
			summaries.agencies.push(lreplace('showresult.filter.summary.excludeTravelAgencies', { agencies: agenciesStr }));
		}

		if (filtered.hasOwnProperty('sortEmission')) {
			summaries.sortings.push(l('showresult.filter.summary.emissionSorting'));
		}

		// Now render...

		for (const summary in summaries) {
			if (summaries.hasOwnProperty(summary)) {
				const section = qs(`#filter-${summary}-section .filtersView__summary`, html);
				const texts = summaries[summary];

				if (texts.length) {
					let html = '';

					for (let i = 0; i < texts.length; i++) {
						html += `
								<li>
									<span>${texts[i]}</span>
								</li>
							`;
					}

					section.innerHTML = `<ul class="filtersList filtersList--summary">${html}</ul>`;
				} else {
					section.innerHTML = '';
				}
			}
		}
	}

	setTimeDefaults (index, data, type) {
		const currentFilters = window.showresult.searchParams.filters;
		const typeTime = (type === 'departures') ? 'departureTime' : 'arrivalTime';
		let typeTimeSlideClosestKeyStart = null;
		let typeTimeSlideClosestKeyEnd = null;

		if (typeof currentFilters !== 'undefined' && typeof currentFilters[typeTime] !== 'undefined') {
			const foundTime = currentFilters[typeTime].find(trip => trip.tripIndex === index);

			if (foundTime) {
				typeTimeSlideClosestKeyStart = this.findClosestTimeSliderKey(data[type], foundTime.start);
				typeTimeSlideClosestKeyEnd = this.findClosestTimeSliderKey(data[type], foundTime.end);

				if (typeof typeTimeSlideClosestKeyStart !== 'undefined' && typeTimeSlideClosestKeyEnd) {
					if (type === 'departures') {
						return [typeTimeSlideClosestKeyStart, typeTimeSlideClosestKeyEnd];
					} else {
						return [typeTimeSlideClosestKeyStart, typeTimeSlideClosestKeyEnd];
					}
				}
			}
		}

		return false;
	}

	findClosestTimeSliderKey (arr, value) {
		// need to check for first key with the same hour-min as value if it is to be supported in other trips
		for (let i = 0, len = arr.length; i < len; i++) {
			if (arr[i] >= value) {
				return i;
			}
		}

		return false;
	}

	buildAirportHTML (arr) {
		let html = '';

		for (let i = 0; i < arr.length; i++) {
			const airport = arr[i];

			html += `
				<li>
					<label for="${airport.id}" class="checkbox" tabindex="0">
						<input id="${airport.id}" type="checkbox" ${airport.selected ? `checked="checked"` : ``} value="${airport.value}">
						<div class="checkbox__tick">
							<div class="checkbox__tick--svg">${checktick}</div>
							<span class="iata">${airport.airport}, ${airport.iata}</span>
						</div>
					</label>
					${this.generateExclusiveButton()}
				</li>
			`;
		}

		return html;
	}

	buildTimetableHTML (index, data, btns) {
		return `
<section class="filtersSection">
	<div class="filtersTimetable filtersTimetable--${index}" data-index="${index}">
		<h3 class="filtersTimetable__title">
			<span class="icon icon-circle-plane-${data.icon}"></span>
			<span>${data.fromTo}</span>
		</h3>
		<div class="filtersSlider">
			<h3 class="filtersSlider__title">
				<span>${l('showresult.filter.departureText')}</span>
			</h3>
			<div class="filtersSlider__value">
				<span id="slider-timetable-departure-text-${index}"></span>
			</div>
			<div class="sliderWrapper sliderWrapper--filter">
				<div id="slider-timetable-departure-${index}" class="filter-slider"></div>
			</div>
		</div>
		<div class="filtersTimetableBtns grid-3-noBottom">
			<div class="col">
				<button class="filtersTimetableBtns__btn" data-index="0" ${!btns.morning ? 'disabled' : ''}>
					<span>${l('showresult.filter.travelTime.morning')}</span>
				</button>
			</div>
			<div class="col">
				<button class="filtersTimetableBtns__btn" data-index="1" ${!btns.afternoon ? 'disabled' : ''}>
					<span>${l('showresult.filter.travelTime.afternoon')}</span>
				</button>
			</div>
			<div class="col">
				<button class="filtersTimetableBtns__btn" data-index="2" ${!btns.evening ? 'disabled' : ''}>
					<span>${l('showresult.filter.travelTime.evening')}</span>
				</button>
			</div>
		</div>
		<div class="filtersSlider">
			<h3 class="filtersSlider__title">
				<span>${l('showresult.filter.arrivalText')}</span>
			</h3>
			<div class="filtersSlider__value">
				<span id="slider-timetable-arrival-text-${index}"></span>
			</div>
			<div class="sliderWrapper sliderWrapper--filter">
				<div id="slider-timetable-arrival-${index}" class="filter-slider"></div>
			</div>
		</div>
	</div>
</section>`;
	}

	createWaitingTimeSlider () {
		const sliderElement = qs('#slider-min-max-waiting', this.html);
		if (typeof sliderElement.noUiSlider !== 'undefined') {
			sliderElement.noUiSlider.destroy();
		}

		const selected = [0, this._data.uniqueWaittime.length - 1];

		if (window.showresult?.searchParams?.filters?.airportWaitTime?.length) {
			const selected1 = window.showresult.searchParams.filters.airportWaitTime[0];
			const selected2 = window.showresult.searchParams.filters.airportWaitTime[1];
			selected[0] = this._data.uniqueWaittime.findIndex(time => time >= selected1) || 0;
			selected[1] = this._data.uniqueWaittime.findIndex(time => time >= selected2) || this._data.uniqueWaittime.length - 1;
		}


		noUiSlider.create(sliderElement, {
			start: selected,
			connect: [false, true, false],
			tooltips: [false, false],
			range: {
				min: [0],
				max: [this._data.uniqueWaittime.length - 1]
			},
			handleAttributes: [
				{ 'aria-label': `Min ${l('showresult.filter.waitingTime')}` },
				{ 'aria-label': `Max ${l('showresult.filter.waitingTime')}` }
			]
		});

		// const tooltip = qsa('.noUi-tooltip', sliderElement);
		const persistentTooltip = qs('#slider--min-max-waiting-text', this.html);

		persistentTooltip.innerHTML = `${getTimeText(this._data.uniqueWaittime[selected[0]])} - ${getTimeText(this._data.uniqueWaittime[selected[1]])}`;

		sliderElement.noUiSlider.on('update', (values, handle) => {
			const time1 = this._data.uniqueWaittime[Math.round(values[0])];
			const time2 = this._data.uniqueWaittime[Math.round(values[1])];
			// tooltip[handle].innerHTML = getTimeText(time1);
			persistentTooltip.innerHTML = `${getTimeText(time1)} - ${getTimeText(time2)}`;
			const maxWaitTime = this._data.uniqueWaittime.length > 5 ? this._data.uniqueWaittime[Math.floor(this._data.uniqueWaittime.length / 5)] : 10800;
			const indexOfMaxWaitTime = this._data.uniqueWaittime.indexOf(maxWaitTime);
			const inputElement = qs('#hide-airport-waittime', this.html);
			if (values[1] <= indexOfMaxWaitTime) {
				inputElement.checked = true;
			} else {
				inputElement.checked = false;
			}
		});

		sliderElement.noUiSlider.on('change', () => {
			this.update();
		});
	}

	createTimeFilter (index, data, filtered) {
		const { activeTimetableBtns } = filtered;

		const departTimeSet = this.setTimeDefaults(index, data, 'departures');
		const arrivalTimeSet = this.setTimeDefaults(index, data, 'arrivals');

		const departureTimeDefault = departTimeSet || [0, data.departures.length - 1];
		const arrivalTimeDefault = arrivalTimeSet || [0, data.arrivals.length - 1];

		/*
			 * departure/arrival time sliders
			 */

		const timetable = qs(`.filtersTimetable--${index}`, this.html);

		if (!timetable) {
			return;
		}

		const filterTimetable = timetable.querySelector('.filtersTimetableBtns');

		const departSlider = timetable.querySelector(`#slider-timetable-departure-${index}`);
		const departSliderText = timetable.querySelector(`#slider-timetable-departure-text-${index}`);

		const arrivalSlider = timetable.querySelector(`#slider-timetable-arrival-${index}`);
		const arrivalSliderText = timetable.querySelector(`#slider-timetable-arrival-text-${index}`);

		const slide = (slider, values, handle, type) => {
			const sliderIndex = parseInt(slider.id.substr(-1, 1), 10);
			const sliderValue = Math.round(values[handle]);
			const tooltipDate = dateFormat(new Date(this._data.uniqueTimes[sliderIndex][type][sliderValue] * 1000), 'd MMM');
			const tooltip = slider.querySelectorAll('.noUi-tooltip')[handle];

			const value1 = Math.round(values[0]);
			const value2 = Math.round(values[1]);

			const start = data[type][value1];
			const end = data[type][value2];

			const time1 = this.getFlightTimeText(start);
			const time2 = this.getFlightTimeText(end);

			const text = `${time1} - ${time2}`;

			if (type === 'departures') {
				departSliderText.innerText = text;
			} else {
				arrivalSliderText.innerText = text;
			}

			tooltip.innerHTML = tooltipDate;
		};

		/*
			 * set active timetable buttons
			 */

		if (activeTimetableBtns) {
			for (const btn in activeTimetableBtns) {
				if (activeTimetableBtns.hasOwnProperty(btn)) {
					if (index === activeTimetableBtns[btn].timetableIndex) {
						const btnIndex = activeTimetableBtns[btn].btnIndex;
						const activeBtn = filterTimetable.querySelectorAll('button');

						activeBtn[btnIndex].classList.add('filtersTimetableBtns__btn--active');
					}
				}
			}
		}

		/*
			 * create & set departure/arrival time sliders
			 */

		noUiSlider.create(departSlider,
			{
				start: departureTimeDefault,
				connect: [false, true, false],
				tooltips: [true, true],
				range: {
					min: [0],
					max: [data.departures.length - 1]
				},
				handleAttributes: [
					{ 'aria-label': `Min` },
					{ 'aria-label': `Max` }
				]
			});

		noUiSlider.create(arrivalSlider,
			{
				start: arrivalTimeDefault,
				connect: [false, true, false],
				tooltips: [true, true],
				range: {
					min: [0],
					max: [data.arrivals.length - 1]
				},
				handleAttributes: [
					{ 'aria-label': `Min` },
					{ 'aria-label': `Max` }
				]
			});

		departSlider.noUiSlider.on('update', (values, handle) => slide(departSlider, values, handle, 'departures'));
		departSlider.noUiSlider.on('set', () => this.sliderChange(departSlider));
		departSlider.noUiSlider.on('slide', () => {
			// clear active timetable buttons.
			const activeBtn = filterTimetable.querySelector('.filtersTimetableBtns__btn--active');

			if (activeBtn) {
				activeBtn.classList.remove('filtersTimetableBtns__btn--active');
			}
		});

		arrivalSlider.noUiSlider.on('update', (values, handle) => slide(arrivalSlider, values, handle, 'arrivals'));
		arrivalSlider.noUiSlider.on('set', () => this.sliderChange(arrivalSlider));
	}

	findClosestSliderKey (arr, value) {
		for (let i = 0, len = arr.length; i < len; i++) {
			if (arr[i] >= value) {
				return i;
			}
		}

		return arr.length - 1;
	}

	sliderChange (slider) {
		if (this._sliderTimer) {
			return;
		}

		this._sliderTimer = setTimeout(() => {
			if (this._freezeSliders) {
				return;
			}

			trackEvent.triggerGAevent('filterSliders', slider.id);

			this.update();
			this._sliderTimer = null;
		}, 100);
	}

	renderPriceSlider (selectedPrice) {
		const data = this._data;
		const sliderPrice = qs('#slider-price', this.html);

		let priceSlideDefault = data.uniquePrices.length - 1;
		let priceSlideClosestKey = priceSlideDefault || 1;

		if (selectedPrice) {
			priceSlideDefault = selectedPrice;
			priceSlideClosestKey = this.findClosestSliderKey(data.uniquePrices, priceSlideDefault);
		}

		if (typeof sliderPrice.noUiSlider !== 'undefined') {
			sliderPrice.noUiSlider.destroy();
		}

		const priceSlide = (values, handle) => {
			const value = Math.round(values[0]);
			const price = (data.uniquePrices.length === 1) ? data.uniquePrices[0] : data.uniquePrices[value];
			const sliderPriceText = qs('#slider-price-text', this.html);

			sliderPriceText.innerHTML = lc(price || 0, true);
		};

		if (sliderPrice.noUiSlider) {
			sliderPrice.noUiSlider.destroy();
		}

		noUiSlider.create(sliderPrice,
			{
				start: [priceSlideClosestKey],
				connect: [true, false],
				range: {
					min: 0,
					max: data.uniquePrices.length - 1 || 1
				},
				handleAttributes: [
					{ 'aria-label': `Price` }
				]
			});

		if (!selectedPrice && priceSlideDefault === -1) {
			sliderPrice.setAttribute('disabled', true);
		} else {
			sliderPrice.removeAttribute('disabled');
		}

		sliderPrice.noUiSlider.on('update', priceSlide);
		sliderPrice.noUiSlider.on('change', () => this.sliderChange(sliderPrice));

		priceSlide([priceSlideClosestKey], 0);
	}

	renderFooter () {
		const cheapestPrice = lc(resultsRender?.response?.sortingButtons?.cheapest);
		const resultCount = resultsRender?.response?.meta?.resultCount;
		const filtersElem = this.html;
		const filtersFooterResults = filtersElem.querySelector('#filtersFooterResults');
		const filtersFooterPrice = filtersElem.querySelector('#filtersFooterPrice');
		const filtersApplyBtn = filtersElem.querySelector('button.abBtn--hideFilters');

		if (filtersFooterResults && filtersFooterPrice) {
			if (resultCount > 0 && cheapestPrice) {
				const noOfResults = `<b>${resultCount}</b>`;

				filtersFooterResults.classList.remove('filtersFooter__results--noResults');
				filtersFooterResults.innerHTML = lreplace('showresult.filter.filtered_results', { x: noOfResults });

				filtersFooterPrice.classList.remove('filtersFooter__price--noResults');
				filtersFooterPrice.innerHTML = lreplace('showresult.filter.price_from', { price: cheapestPrice });

				filtersApplyBtn.disabled = false;

				// TODO: renable???
				// if (isResultList && !this.isMobile) {
				// 	if (document.querySelector('.results-container .abResult').clientHeight * resultCount <= window.innerHeight) {
				// 		window.scrollTo({ top: this.initFetchScrollPos });
				// 	}
				// }
			} else {
				const noOfResults = `<b>${resultCount}</b>`;
				filtersFooterResults.innerHTML = lreplace('showresult.filter.filtered_results', { x: noOfResults });
				filtersFooterPrice.classList.add('filtersFooter__price--noResults');
				filtersFooterPrice.innerHTML = l('showresult.filter.no_results_on_current_filter');

				filtersApplyBtn.disabled = true;
			}
		}
	}

	update (fullUpdate = true) {
		const filtered = this.get();

		const enabledEvents = {
			airportsArrivals: events.filterAirportsArrivalEnabled,
			airportsDepartures: events.filterAirportsDepartureEnabled,
			airportStops: events.filterAirportsStopsEnabled,
			airportWaitTime: events.filterNoLongTransferTimeEnabled,
			alliances: events.filterAllianceEnabled,
			blacklisted: events.filterBlacklistedEnabled,
			enabledAirlines: events.filterAirlinesEnabled,
			travelTime: events.filterTravelTimeEnabled,
			numStops: events.filterStopsEnabled,
			changesAirport: events.filterDirectFlightOnlyEnabled,
			// climateCompensated: events.filterCO2CompensateEnabled, Handled in showresults
			departureTime: events.filterDepartureTimeEnabled,
			enabledAgents: events.filterTravelCompanyEnabled,
			arrivalTime: events.filterArrivalTimeEnabled,
			activeTimetableBtns: events.filterActiveTimetableEnabled,
			flexTicket: events.filterRebookableEnabled,
			baggageIncluded: events.filterBaggageEnabled,
			cabinBaggageIncluded: events.filterCabinBaggageEnabled,
			paymentMethodIncluded: events.filterPaymentMethodEnabled,
			foreign: events.filterHideForeignTravelAgenciesEnabled,
			// Sorting:
			sortEmission: events.sortByCO2EmissionEnabled
		};

		const disabledEvents = {
			airportsArrivals: events.filterAirportsArrivalDisabled,
			airportsDepartures: events.filterAirportsDepartureDisabled,
			airportStops: events.filterAirportsStopsDisabled,
			airportWaitTime: events.filterNoLongTransferTimeDisabled,
			alliances: events.filterAllianceDisabled,
			blacklisted: events.filterBlacklistedDisabled,
			enabledAirlines: events.filterAirlinesDisabled,
			travelTime: events.filterTravelTimeDisabled,
			numStops: events.filterStopsDisabled,
			changesAirport: events.filterDirectFlightOnlyDisabled,
			// climateCompensated: events.filterCO2CompensateDisabled, Handled in showresults
			departureTime: events.filterDepartureTimeDisabled,
			enabledAgents: events.filterTravelCompanyDisabled,
			arrivalTime: events.filterArrivalTimeDisabled,
			activeTimetableBtns: events.filterActiveTimetableDisabled,
			flexTicket: events.filterRebookableDisabled,
			baggageIncluded: events.filterBaggageDisabled,
			cabinBaggageIncluded: events.filterCabinBaggageDisabled,
			paymentMethodIncluded: events.filterPaymentMethodDisabled,
			foreign: events.filterHideForeignTravelAgenciesDisabled,
			// Sorting:
			sortEmission: events.sortByCO2EmissionDisabled
		};

		// Check enabled
		for (const filter in filtered) {
			if (Object.prototype.hasOwnProperty.call(filtered, filter) && !Object.prototype.hasOwnProperty.call(this._filtered, filter)) {
				logEvent(enabledEvents[filter], eventCategories.filter, JSON.stringify(this._filtered[filter]));
			} else if (Object.prototype.hasOwnProperty.call(filtered, filter) && Object.prototype.hasOwnProperty.call(this._filtered, filter)) {
				// Both keys exist, we need to see if they are different
				if (JSON.stringify(filtered[filter]) !== JSON.stringify(this._filtered[filter])) {
					logEvent(enabledEvents[filter], eventCategories.filter, JSON.stringify(this._filtered[filter]));
				}
			}
		}

		// Check disabled
		for (const unfilter in this._filtered) {
			if (!Object.prototype.hasOwnProperty.call(filtered, unfilter) && Object.prototype.hasOwnProperty.call(this._filtered, unfilter)) {
				logEvent(disabledEvents[unfilter], eventCategories.filter);
			}
		}

		// Update the filtered object
		this._filtered = filtered;

		if (Object.keys(filtered).length > 0) {
			storedItemCreate('savedFilters', filtered);
		}

		this.renderFilterNavBtns(filtered);

		this.renderFilterSummaries(filtered);

		if (fullUpdate && this._callbacks.onUpdate) {
			return this._callbacks.onUpdate(filtered);
		}
	}

	get () {
		const filtered = {};
		const data = this._data;
		const html = this.html;
		const timetables = qsa('.filtersTimetable', html);
		const stops = qs('#stops-filters input:checked', html);
		const sliderPrice = qs('#slider-price', html);
		const sliderWaitingTime = qs('#slider-min-max-waiting', html);
		const sliderTravelTime = qs('#slider-traveltime', html);
		const hideAirportWaittime = qs('#hide-airport-waittime', html);
		const paymentMethodIncluded = qs('#filter-paymentmethod-select', html);
		const climateCompensated = qs('#show-climate-compensation', html);

		const waitingTime = sliderWaitingTime.noUiSlider.get();
		const price = Math.round(sliderPrice.noUiSlider.get());
		const travelTime = Math.round(sliderTravelTime.noUiSlider.get());

		const airportStops = [];
		const airportDepartures = [];
		const airportArrivals = [];

		let airlines = [];
		const enabledAgents = [];

		if (Math.round(waitingTime[0]) !== 0 || Math.round(waitingTime[1]) !== data.uniqueWaittime.length - 1) {
			filtered.airportWaitTime = [data.uniqueWaittime[Math.round(waitingTime[0])], data.uniqueWaittime[Math.round(waitingTime[1])]];
		}

		if (price !== data.uniquePrices.length - 1) {
			filtered.price = data.uniquePrices[price];
		}

		if (travelTime !== data.uniqueMaxTraveltimePerTrip.length - 1) {
			filtered.traveltime = data.uniqueMaxTraveltimePerTrip[travelTime];
		}

		if (stops.value !== 'false') {
			filtered.numStops = parseInt(stops.value, 10);
		}

		if (climateCompensated.checked) {
			filtered.climateCompensated = 1;
		}


		const selectedAlliances = qsa('#filter-alliances input[type=checkbox]:checked', html);
		if (selectedAlliances.length > 0) {
			filtered.alliances = selectedAlliances.map(({ value }) => value);
		}

		/*
			 * Timetables
			 */

		if (timetables.length > 0) {
			const departureTime = [];
			const arrivalTime = [];
			const activeBtns = [];

			timetables.forEach((timetable, index) => {
				const sliders = qsa('.filter-slider', timetable);

				let departure = sliders[0].noUiSlider.get();
				let arrival = sliders[1].noUiSlider.get();

				departure = departure.map(value => Math.round(value));
				arrival = arrival.map(value => Math.round(value));

				if (departure[0] !== 0 || departure[1] !== data.uniqueTimesOffset[index].departures.length - 1) {
					const departureStart = data.uniqueTimesOffset[index].departures[departure[0]];
					const departureEnd = data.uniqueTimesOffset[index].departures[departure[1]];

					departureTime.push({ tripIndex: index, start: departureStart, end: departureEnd });
				}

				if (arrival[0] !== 0 || arrival[1] !== data.uniqueTimesOffset[index].arrivals.length - 1) {
					const arrivalStart = data.uniqueTimesOffset[index].arrivals[arrival[0]];
					const arrivalEnd = data.uniqueTimesOffset[index].arrivals[arrival[1]];

					arrivalTime.push({ tripIndex: index, start: arrivalStart, end: arrivalEnd });
				}

				const activeBtn = qs('.filtersTimetableBtns__btn--active', timetable);

				if (activeBtn) {
					activeBtns.push({
						timetableIndex: index,
						btnIndex: parseInt(activeBtn.dataset.index, 10)
					});
				}
			});

			if (departureTime.length > 0) {
				filtered.departureTime = departureTime;
			}

			if (arrivalTime.length > 0) {
				filtered.arrivalTime = arrivalTime;
			}

			if (activeBtns.length > 0) {
				filtered.activeTimetableBtns = activeBtns;
			}
		}

		/*
			 * Airports
			 */

		qsa('#filter-airports-stops input[type=checkbox][data-type=city]:not(:checked)', html)
			.forEach(checkbox => airportStops.push(checkbox.value));

		qsa('#filter-airports-departures input[type=checkbox]:not(:checked)', html)
			.forEach(checkbox => airportDepartures.push(checkbox.value));

		qsa('#filter-airports-arrivals input[type=checkbox]:not(:checked)', html)
			.forEach(checkbox => airportArrivals.push(checkbox.value));

		if (airportStops.length > 0) {
			filtered.airportStops = airportStops;
		}

		if (airportDepartures.length > 0) {
			filtered.airportDepartures = airportDepartures;
		}

		if (airportArrivals.length > 0) {
			filtered.airportArrivals = airportArrivals;
		}

		if (qs('#hide-changes-airport', html).checked) {
			filtered.changesAirport = true;
		}

		if (qs('#hide-blacklisted', html).checked) {
			filtered.blacklisted = true;
		}


		if (qs('#hide-foreign', html).checked) {
			filtered.foreign = true;
		}

		if (js_params.disabledAgents) {
			filtered.disabledAgents = js_params.disabledAgents;
		}

		if (qs('#show-flex-ticket', html).checked) {
			filtered.flexTicket = 1;
		}

		if (this._isYouthSearch) {
			if (qs('#show-youth-ticket', html).checked) {
				filtered.youthTicket = 1;
			} else {
				filtered.youthTicket = 0;
			}
		}

		const cancellationProtection = qs('#show-cancellation-protection', html);
		if (cancellationProtection && cancellationProtection.checked) {
			filtered.cancellationProtection = 1;
		}

		if (qs('#show-baggage-included', html).checked) {
			filtered.baggageIncluded = js_params.passengers - js_params.infants;
		}

		if (html.querySelector('#show-cabin-baggage-included').checked) {
			filtered.cabinBaggageIncluded = js_params.passengers - js_params.infants;
		}

		// TODO: future release...
		// if (html.querySelector('#filtersBaggagePerPersonRadio').checked)
		// {
		// 	const value = parseInt(html.querySelector('#filtersBaggagePerPersonBtns').dataset.value, 10);
		// 	filtered.filtersBaggagePerPerson = value;
		// }
		// else if (html.querySelector('#filtersBaggageTotalRadio').checked)
		// {
		// 	const value = parseInt(html.querySelector('#filtersBaggageTotalBtns').dataset.value, 10);
		// 	filtered.filtersBaggageTotal = value;
		// }
		// }

		// TODO: future release...
		// if (html.querySelector('#filtersBaggagePerPersonRadio').checked)
		// {
		// 	const value = parseInt(html.querySelector('#filtersBaggagePerPersonBtns').dataset.value, 10);
		// 	filtered.filtersBaggagePerPerson = value;
		// }
		// else if (html.querySelector('#filtersBaggageTotalRadio').checked)
		// {
		// 	const value = parseInt(html.querySelector('#filtersBaggageTotalBtns').dataset.value, 10);
		// 	filtered.filtersBaggageTotal = value;
		// }

		// if (html.querySelector('#show-rebookable').checked)
		// {
		// 	filtered.rebookableFlights = 1;
		// }

		/*
			 * Payment methods
			 */

		if (parseInt(paymentMethodIncluded.value, 10)) {
			filtered.paymentMethodIncluded = parseInt(paymentMethodIncluded.value, 10);
		}

		/*
			 * Airlines
			 */

		html.querySelectorAll('#filter-airlines input:checked').forEach((checkbox) => {
			if (checkbox.value.length > 2) {
				airlines = [...airlines, ...checkbox.value.split('_')];
			} else {
				airlines.push(checkbox.value);
			}
		});

		if (airlines.length && airlines.length !== Object.keys(data.airlineDetails).length) {
			filtered.enabledAirlines = airlines;

			if (data.airlineMissing) {
				filtered.enabledAirlines.push(...data.airlineMissing);
			}
		}

		/*
			 * Agencies
			 */

		// get all checked agencies
		const allAgencies = qsa('#filter-agencies-options input', html);
		const allEnabledAgencies = allAgencies.filter(checkbox => checkbox.checked);
		if (allEnabledAgencies.length !== allAgencies.length) {
			filtered.enabledAgents = allEnabledAgencies.map(checkbox => checkbox.value);
		}

		/*
			 * Sortings
			 */

		if (qs('#sort-emission', html).checked === true) {
			filtered.sortEmission = true;
		}

		// Now return filtered data

		return filtered;
	}

	set (obj) {
		this._data = obj?.data || this._data;
		this._filtered = obj?.filtered || this._filtered;

		const data = this._data;
		const filtered = this._filtered;
		const filtersHTML = {
			alliances: [],
			enabledAirlines: [],
			payments: [],
			paymentMethodIncluded: [],
			countryAirports: [],
			airportsDeparture: [],
			airportsArrival: [],
			travelAgencies: [],
			stops: [],
			isBeta: js_params.isbeta,
			completePriceEnabled: js_params.completePriceEnabled
		};

		filtersHTML.numStops = (filtered.numStops >= 0) ? filtered.numStops.toString() : false;
		filtersHTML.foreign = filtered.foreign || false;
		filtersHTML.changesAirport = filtered.changesAirport || false;
		filtersHTML.blacklisted = filtered.blacklisted || false;
		filtersHTML.airportWaitTime = filtered.airportWaitTime ? true : false;
		filtersHTML.agenciesAll = filtered.enabledAgents ? true : false;
		filtersHTML.airlinesAll = filtered.enabledAirlines ? true : false;
		filtersHTML.airportsAll = filtered.airportStops || filtered.airportArrivals || filtered.airportDepartures ? true : false;
		filtersHTML.paymentMethodsAll = filtered.paymentMethods ? true : false;
		filtersHTML.baggageIncluded = filtered.baggageIncluded || false;
		filtersHTML.cabinBaggageIncluded = filtered.cabinBaggageIncluded || false;
		// filtersHTML.rebookableFlights = filtered.rebookableFlights || false;
		const presetFilters = Object.keys(filtered).filter(filterKey => !['alternativeHashes', 'groupBy', 'groupByMultiple'].includes(filterKey));
		filtersHTML.savedFilters = (presetFilters) ? presetFilters.length > 0 : false;
		filtersHTML.climateCompensationEnabled = js_params.domain === 'flygresor.se';
		filtersHTML.climateCompensated = filtered.climateCompensated || false;
		filtersHTML.flexTicket = filtered.flexTicket || false;
		filtersHTML.activeTimetableBtns = filtered.activeTimetableBtns || false;
		filtersHTML.departureTime = filtered.departureTime || false;
		filtersHTML.arrivalTime = filtered.arrivalTime || false;
		filtersHTML.sortEmission = filtered.sortEmission || false;
		filtersHTML.collapsed = filtered.collapsed || false;

		if (this._isYouthSearch) {
			filtersHTML.youthTicket = filtered.youthTicket || false;
		}

		// Alliances

		for (let i = 0; i < data.uniqueAlliances.length; ++i) {
			const alliance = data.uniqueAlliances[i];
			const id = 'filter-alliance-' + alliance.toLowerCase().replace(' ', '-');
			let allianceName = alliance.charAt(0).toUpperCase() + alliance.slice(1);

			allianceName = allianceName.replace('alliance', 'Alliance');

			if (alliance == 'alliancefree') {
				allianceName = l('showresult.filters.showAllianceFree', 'Visa alliansfria flygbolag');
			}


			filtersHTML.alliances.push({ id: id, value: alliance.toLowerCase(), alliance: allianceName, checked: filtered?.alliances?.includes?.(alliance) });
		}

		// Airlines

		const uniqueAirlines = [];

		for (const enabledAirline in data.airlineDetails) {
			if (data.airlineDetails.hasOwnProperty(enabledAirline)) {
				let found = false;

				for (let i = 0; i < uniqueAirlines.length; i++) {
					if (uniqueAirlines[i].val === data.airlineDetails[enabledAirline]) {
						uniqueAirlines[i].key = uniqueAirlines[i].key + '_' + enabledAirline;
						found = true;
						break;
					}
				}

				if (found === false) {
					uniqueAirlines.push({ key: enabledAirline, val: data.airlineDetails[enabledAirline] });
				}
			}
		}

		uniqueAirlines.forEach((obj) => {
			const id = 'filter-airline-' + obj.key.toLowerCase();
			const value = obj.key;
			const airline = (obj.val === '') ? `"${obj.key}"` : obj.val;
			const airlineCodes = value.split('_');
			let selected = true;

			// If no airlines have been filtered out yet then render all checkboxes as selected
			if (!filtered?.enabledAirlines?.length) {
				selected = true;
			} else if (typeof filtered.enabledAirlines === 'undefined' || (airlineCodes.length === 1 && !filtered.enabledAirlines.includes(airlineCodes[0]))) {
				selected = false;
			} else {
				// Case of multiple codes for same airline like DY and D8 both referring to Norwegian (dy_d8)
				// RULE: all individual codes must be listed in filtered.airlines for the airline to be considered filtered out
				let isAirlineFilteredOut = true;
				airlineCodes.forEach((code) => {
					isAirlineFilteredOut &&= filtered.enabledAirlines.includes(code);
				});
				if (!isAirlineFilteredOut) {
					selected = false;
				}
			}

			filtersHTML.enabledAirlines.push({ id, value, airline, selected });
		});

		filtersHTML.enabledAirlines = filtersHTML.enabledAirlines.sort((a, b) => a.airline.localeCompare(b.airline));

		// Payment methods

		filtersHTML.paymentMethodIncluded.push({
			value: 0,
			name: l('showresult.filter.paymentMethodIncluded.chooseMethod'),
			selected: (typeof filtered.paymentMethodIncluded === 'undefined') ? true : false
		});

		data.uniquePaymentMethods.forEach((value) => {
			const method = js_params.module.Filters.paymentMethodsAll[value];

			if (!method) {
				return;
			}

			filtersHTML.paymentMethodIncluded.push(
				{
					value: value,
					name: method,
					selected: (filtered.paymentMethodIncluded && filtered.paymentMethodIncluded === value) ? true : false
				});
		});

		// airports

		const countries = {};
		let counter = 0;

		data.uniqueAirportStops.forEach((airport) => {
			const country = data.airportDetails[airport.iata].country;
			const row = Object.assign({}, airport, { iata: airport.iata });

			if (countries[country]) {
				countries[country].push(row);
			} else {
				countries[country] = [row];
			}
		});

		for (const country in countries) {
			if (countries.hasOwnProperty(country)) {
				let countryDeselected = false;
				const airports = countries[country];

				filtersHTML.countryAirports[counter] = {
					id: `filter-country-${country}`,
					value: country,
					country: country,
					cities: [],
					selected: true
				};

				for (let i = 0; i < airports.length; ++i) {
					const airport = airports[i];
					let price = data.airportPriceMap.stops[airport.iata];
					price = price ? price : '';

					let selected = true;

					if (typeof filtered.airportStops !== 'undefined' && filtered.airportStops.includes(airport.iata)) {
						countryDeselected = true;
						selected = false;
					}

					filtersHTML.countryAirports[counter].cities.push(
						{
							id: `filter-country-airport-${airport.iata}`,
							value: airport.iata,
							city: data.airportDetails[airport.iata].city,
							iata: airport.iata,
							price: price,
							selected: selected
						});
				}

				if (countryDeselected) {
					filtersHTML.countryAirports[counter].selected = false;
				}

				++counter;
			}
		}

		const filterUniqueLocations = [
			{
				selector: '#filter-airports-departures',
				airports: data.uniqueAirportDepartures,
				map: data.airportPriceMap.departures
			},
			{
				selector: '#filter-airports-arrivals',
				airports: data.uniqueAirportArrivals,
				map: data.airportPriceMap.arrivals
			}
		];

		filterUniqueLocations.forEach((unique, index) => {
			const airports = unique.airports;
			const departure = unique.selector === '#filter-airports-departures' || false;
			const airportFilters = departure ? 'airportDepartures' : 'airportArrivals';

			for (let i = 0; i < airports.length; i++) {
				const airport = airports[i];
				let price = unique.map[airport.iata];
				price = price ? price : '';

				const obj = {
					id: `filter-airport-${airport.iata}-${index}`,
					value: airport.iata,
					iata: airport.iata,
					airport: data.airportDetails[airport.iata].airport,
					price: price,
					selected: (typeof filtered[airportFilters] === 'undefined' || !filtered[airportFilters].includes(airport.iata)) ? true : false
				};

				if (departure) {
					filtersHTML.airportsDeparture.push(obj);
				} else {
					filtersHTML.airportsArrival.push(obj);
				}
			}
		});

		// Travel agencies

		Object.entries(data.travelAgent).forEach((agency) => {
			const code = agency[0];
			const name = agency[1];
			const cName = (typeof js_params.module.Filters.agencies[name] !== 'undefined') ? js_params.module.Filters.agencies[name] : name;

			if (js_params.disabledAgents && js_params.disabledAgents.includes(name)) {
				return;
			}

			filtersHTML.travelAgencies.push(
				{
					id: code,
					agencyValue: name,
					agencyName: cName,
					selected: (typeof filtered.enabledAgents === 'undefined' || filtered.enabledAgents.includes(name)) ? true : false
				});
		});

		filtersHTML.travelAgencies = filtersHTML.travelAgencies.sort(function (a, b) {
			return a.agencyName.localeCompare(b.agencyName);
		});

		// Unique wait time

		if (data.uniqueWaittime !== 'undefined' && data.uniqueWaittime.length > 0) {
			filtersHTML.hasWaitTime = true;
		}

		// Timetables

		if (typeof data.uniqueTimesOffset !== 'undefined') {
			filtersHTML.timetables = [];

			let i = data.uniqueTimesOffset.length - 1;

			for (i; i >= 0; --i) {
				filtersHTML.timetables[i] = {};

				const tripType = js_params?.returntrip || 1;
				const trip = js_params.showresultSearchParams[(tripType === 2) ? i : 0];

				if (trip) {
					const isInbound = tripType === 1 && i === 1;
					const tripFrom = (isInbound) ? trip.to : trip.from;
					const tripTo = (isInbound) ? trip.from : trip.to;

					filtersHTML.timetables[i].icon = (i === 0) ? 'up' : 'down';
					filtersHTML.timetables[i].fromTo = (!tripFrom || !tripTo) ? '' : `${tripFrom} ${l('global.simplePhrases.To', 'to')} ${tripTo}`;
				}
			}
		}


		// TODO: check if this price is actually correct/find a way to show the TRUE lowest price regardless of
		if (this._data?.flights?.length) {
			filtersHTML.cheapestResult = this._data.flights[0].agents[0].price;
		}

		this.render(filtersHTML);

		return this;
	}

	reset (isYouthSearch = false) {
		const html = this.html;
		const toggleCheckboxes = (checkboxes, toggle) => checkboxes.forEach(checkbox => checkbox.checked = toggle);
		const airports = html.querySelectorAll('#filter-airports-section input[type="checkbox"]');
		const enabledAirlines = html.querySelectorAll('#filter-airlines-section input[type="checkbox"]');
		const agencies = html.querySelectorAll('#filter-agencies-section input[type="checkbox"]');
		const alliances = html.querySelectorAll('#filter-alliances input[type="checkbox"]');
		const transfers = html.querySelectorAll('.filtersView--transfers input[type=checkbox]');
		const prices = html.querySelectorAll('.filtersView--prices input[type=checkbox]');

		this._filtered = {};
		this.resetSliders();
		this.toggleLoadFilters(false);

		toggleCheckboxes(airports, true);
		toggleCheckboxes(enabledAirlines, true);
		toggleCheckboxes(agencies, true);
		toggleCheckboxes(alliances, false);
		toggleCheckboxes(transfers, false);
		toggleCheckboxes(prices, false);

		// qs('#filtersBaggageInc', html).classList.remove('filtersBaggageInc--visible');
		qs('#filter-paymentmethod-select', html).value = '0';
		qs('#stops_all', html).checked = true;
		qs('#hide-blacklisted', html).checked = false;
		qs('#hide-foreign', html).checked = false;
		qs('#sort-emission', html).checked = false;
		html.querySelectorAll('.filtersNavBtn--set').forEach(btn => btn.classList.remove('filtersNavBtn--set'));
		html.querySelectorAll('.filtersTimetableBtns__btn').forEach(btn => btn.classList.remove('filtersTimetableBtns__btn--active'));

		if (isYouthSearch) {
			qs('#show-youth-ticket', html).checked = true;
		}

		if (this._callbacks.onReset) {
			this._callbacks.onReset();
		}

		logEvent(events.resetFilters, eventCategories.filter);
	}

	resetSliders () {
		this._freezeSliders = true;

		const sliders = this.html.getElementsByClassName('noUi-target');

		for (let i = 0; i < sliders.length; i++) {
			const slider = sliders[i].noUiSlider;
			const { range, start } = slider.options;
			const hasTwoHandles = start.length > 1;

			if (hasTwoHandles) {
				slider.set([range.min, range.max]);
			} else {
				slider.set([range.max]);
			}
		}

		this._freezeSliders = false;
	}

	toggleLoadFilters (checked) {
		qs('#load-filters', this.html).checked = checked;
	}

	getUniqueDepartTimes (index) {
		const uniqueTimes = this._data.uniqueTimesOffset[index].departures;
		const morningTimes = [];
		const afternoonTimes = [];
		const eveningTimes = [];

		uniqueTimes.forEach((time) => {
			if (time < 43200) {
				morningTimes.push(time);
			} else if (time >= 43200 && time < 61200) {
				afternoonTimes.push(time);
			} else if (time >= 61200) {
				eveningTimes.push(time);
			}
		});

		return {
			morningTimes, afternoonTimes, eveningTimes
		};
	}

	setFiltersHeight () {
		const maxFilterHeigth = window.innerHeight;
		const windowWidth = window.innerWidth;
		const filtersViews = qs('.filtersViews', this.html);

		let height = 0;

		if (windowWidth < 768) {
			this.html.style.height = '';

			const initialHeight = filtersViews.clientHeight;
			height = maxFilterHeigth - filtersViews.getBoundingClientRect().top - qs('.filtersFooter', this.html).clientHeight;

			if (height !== initialHeight) {
				filtersViews.style.height = height + 'px';
			}
		} else {
			filtersViews.style.height = '';

			const initialHeight = this.html.clientHeight;
			if (initialHeight !== maxFilterHeigth) {
				this.html.style.height = maxFilterHeigth + 'px';
			}
		}
	}

	getFiltersScrollHeight () {
		const filtersContent = qs('.filtersContent', this.html);

		const fullHeight = qs('.filtersLayout', this.html).clientHeight + filtersContent.querySelector('.filtersTop').clientHeight;
		const visibleHeight = filtersContent.clientHeight;
		const scrollHeight = fullHeight - visibleHeight;

		return scrollHeight;
	}

	showScrollBtn (btn) {
		if (!btn.classList.contains('filtersScrollBtn--visible')) {
			btn.classList.add('filtersScrollBtn--visible');

			if (!qs('#filters').classList.contains('scrolled') && btn.classList.contains('filtersScrollBtn--up')) {
				qs('#filters').classList.add('scrolled');
				logEvent(events.scrollFilterList, eventCategories.scroll);
			}
		}
	}

	hideScrollBtn (btn) {
		if (btn.classList.contains('filtersScrollBtn--visible')) {
			btn.classList.remove('filtersScrollBtn--visible');
			if (btn.classList.contains('filtersScrollBtn--down')) {
				btn.style.bottom = '';
			}
		}
	}

	show () {
		this.html.classList.toggle('filters--visible');
		document.body.classList.add('modal-open');

		this.setFiltersHeight();
		setTimeout(() => {
			this._events.onScroll();
		}, 1000);
		if (this._callbacks.onShow) {
			setTimeout(() => this._callbacks.onShow(), 200);
		}

		this.popStateHelper.open();
	}

	hide () {
		this.popStateHelper.destroy();
		this.html.classList.remove('filters--visible');
		document.body.classList.remove('modal-open');

		if (this._callbacks.onShow) {
			setTimeout(() => this._callbacks.onHide(), 200);
		}

		if (document.body.classList.contains('tabmode')) {
			// Remove tabindex from the tabable elements
			gebi('filterMobileNav').querySelectorAll('[tabindex]').forEach((elem) => {
				elem.tabIndex = -1;
			});
		}
	}

	generateExclusiveButton () {
		return `<span class="exclusiveButton">${l('global.simplePhrases.only')}</span>`;
	}

	getFlightTimeText (time) {
		let d = Number(time);

		// calculate (and subtract) whole days
		const days = Math.floor(d / 86400);
		d -= days * 86400;

		// calculate (and subtract) whole hours
		const hours = Math.floor(d / 3600) % 24;
		d -= hours * 3600;

		// calculate whole minutes
		const minutes = Math.floor(d / 60) % 60;

		return addZero(hours) + ':' + addZero(minutes);
	}

	initEvents () {
		const views = qsa('.filtersView');
		const content = qs('.filtersContent', this.html);
		const scrollUpBtn = qs('.filtersScrollBtn--up', this.html);
		const scrollDownBtn = qs('.filtersScrollBtn--down', this.html);
		const scrollOffset = 83;

		// Return index for view that is closest to scrollTop position.
		const getViewIndex = () => {
			const calcScrollTop = scrollTop + scrollOffset;
			const tops = views.map(view => view.offsetTop);
			const closest = tops.reduce((prev, curr) => (Math.abs(curr - calcScrollTop) < Math.abs(prev - calcScrollTop) ? curr : prev));
			const index = tops.indexOf(closest);
			return index;
		};

		let scrollTop = 0;
		let scrollTimer = null;

		qs('.abHeader__btn--showresultBackBtn').addEventListener('click', (event) => {
			// If filters are visible, hide them and prevent default back button behavior
			if (this.html.classList.contains('filters--visible')) {
				this.hide();
				event.preventDefault();
				event.stopPropagation();
			}
		});

		this._events.onClick = (e) => {
			const elem = e.target;

			if (elem.closest('#hide-airport-waittime')) {
				const sliderElement = qs('#slider-min-max-waiting', this.html);
				const waitTimeToggled = elem.closest('#hide-airport-waittime')?.checked;

				if (sliderElement && waitTimeToggled !== undefined) {
					const uniqueWaitTimes = this._data.uniqueWaittime;
					const waitTimeLength = uniqueWaitTimes.length;

					if (waitTimeToggled) {
						const maxWaitTime = waitTimeLength > 5
							? uniqueWaitTimes[Math.floor(waitTimeLength / 5)]
							: 10800;
						const indexOfMaxWaitTime = uniqueWaitTimes.indexOf(maxWaitTime);

						const maitTimeIndex = indexOfMaxWaitTime > -1
							? indexOfMaxWaitTime
							: waitTimeLength - 1;
						const minWaitTime = this._filtered.airportWaitTime?.[0] ? uniqueWaitTimes.indexOf(this._filtered.airportWaitTime[0]) : 0;

						sliderElement.noUiSlider.set([minWaitTime, maitTimeIndex]);
					} else {
						sliderElement.noUiSlider.set([0, waitTimeLength - 1]);
					}
				}
			}

			if (elem.classList.contains('exclusiveButton')) {
				let filtersList = elem.closest('.filtersList');
				// If sublist find parent list
				if (filtersList.classList.contains('filtersList--inner')) {
					filtersList = filtersList.parentElement.closest('.filtersList');
				}
				const elemCheckbox = elem.closest('li');
				const isCountryCheckbox = elemCheckbox.querySelector('input[data-type=country]');
				let whitelistedCheckboxes = [];
				// If country checkbox add all child checkboxes to whitelistedCheckboxes
				if (isCountryCheckbox) {
					const countryList = elem.closest('li');
					const countryLabel = qs('label', countryList);
					const countryCheckbox = qs('input[type="checkbox"]', countryList);
					const cityInputs = qsa('input[type="checkbox"]', countryLabel.nextElementSibling.nextElementSibling);
					whitelistedCheckboxes = [countryCheckbox, ...cityInputs];
				} else {
					whitelistedCheckboxes = qsa('input[type="checkbox"]', elemCheckbox);
				}
				qsa('input[type="checkbox"]', filtersList).forEach((checkbox) => {
					checkbox.checked = whitelistedCheckboxes.includes(checkbox);
				});
				e.preventDefault();
				this.update();
				return;
			}

			if (elem === scrollUpBtn || elem === scrollDownBtn) {
				const closestIndex = getViewIndex();

				let view = views[closestIndex];
				let yPos = 0;

				const isAtFold = scrollTop === (view.offsetTop - scrollOffset);

				if (elem === scrollUpBtn) {
					const isAboveFold = scrollTop < (view.offsetTop - scrollOffset);

					if (isAboveFold || isAtFold) {
						view = views[closestIndex - 1];
					}

					if (view) {
						yPos = (view.offsetTop - scrollOffset) < 30 ? 0 : (view.offsetTop - scrollOffset);
					}
				}

				if (elem === scrollDownBtn) {
					const isBelowFold = scrollTop > (view.offsetTop - scrollOffset);

					if (isBelowFold || isAtFold || closestIndex === 0) {
						view = views[closestIndex + 1];
					}

					yPos = view.offsetTop - scrollOffset;
				}
				const lastViewProximity = yPos + content.clientHeight - scrollOffset;
				if (lastViewProximity > content.scrollHeight && this.html.getBoundingClientRect().top > 0) {
					window.scrollTo({
						top: getOffset(this.html).top,
						behavior: 'smooth'
					});
				}
				content.scrollTo({
					top: yPos,
					behavior: 'smooth'
				});

				return;
			}

			if (elem.dataset.action === 'reset-filters') {
				storedItemDelete('savedFilters');
				this.reset();
				return;
			}

			if (elem.classList.contains('filtersNavBtn')) {
				if (!elem.classList.contains('filtersNavBtn--active')) {
					const filtersViews = qs('.filtersViews', this.html);
					const views = filtersViews.children;
					const filtersNavBtns = elem.parentElement.children;
					const index = getNodeIndex(elem);

					for (let i = 0; i < views.length; i++) {
						views[i].classList.remove('filtersView--visible');
					}

					for (let i = 0; i < filtersNavBtns.length; i++) {
						filtersNavBtns[i].classList.remove('filtersNavBtn--active');
					}

					elem.classList.toggle('filtersNavBtn--active');
					views[index].classList.add('filtersView--visible');

					filtersViews.scrollTop = 0;
				}

				return;
			}

			if (elem.id === 'load-filters') {
				const savedFilters = storedItemRead('savedFilters');

				if (savedFilters) {
					const numOfSavedFilters = Object.keys(savedFilters).length;

					// if no filters in storage, or collapsed is the only filter...
					if (numOfSavedFilters === 0 || (numOfSavedFilters === 1 && savedFilters.hasOwnProperty('collapsed'))) {
						e.preventDefault();
						return;
					}

					if (!elem.checked) {
						this.reset();
					} else {
						this.set({ filtered: savedFilters }).update();
					}
				} else {
					e.preventDefault();
				}

				return;
			}

			if (elem.classList.contains('filtersTimetableBtns__btn')) {
				const wrapper = elem.closest('.filtersTimetableBtns');
				const slider = wrapper.previousElementSibling.querySelector('.filter-slider');

				// if filter is already active then reset the filter
				if (elem.classList.contains('filtersTimetableBtns__btn--active')) {
					elem.classList.remove('filtersTimetableBtns__btn--active');
					const { range } = slider.noUiSlider.options;
					slider.noUiSlider.set([range.min, range.max]);
					return;
				}

				const btnTypes = ['morning', 'afternoon', 'evening'];
				const btnType = btnTypes[parseInt(elem.dataset.index, 10)];
				const btns = qsa('button', wrapper);
				const sliderIndex = parseInt(wrapper.parentElement.dataset.index);
				const uniqueTimes = this._data.uniqueTimesOffset[sliderIndex].departures;
				const {
					morningTimes,
					afternoonTimes,
					eveningTimes
				} = this.getUniqueDepartTimes(sliderIndex);

				let handle1Val = null;
				let handle2Val = null;

				if (btnType === 'morning') {
					handle1Val = uniqueTimes.indexOf(morningTimes[0]);
					handle2Val = uniqueTimes.indexOf(morningTimes[morningTimes.length - 1]);
				} else if (btnType === 'afternoon') {
					handle1Val = uniqueTimes.indexOf(afternoonTimes[0]);
					handle2Val = uniqueTimes.indexOf(afternoonTimes[afternoonTimes.length - 1]);
				} else if (btnType === 'evening') {
					handle1Val = uniqueTimes.indexOf(eveningTimes[0]);
					handle2Val = uniqueTimes.indexOf(eveningTimes[eveningTimes.length - 1]);
				}

				btns.forEach(button => button.classList.remove('filtersTimetableBtns__btn--active'));
				elem.classList.toggle('filtersTimetableBtns__btn--active');

				slider.noUiSlider.set([handle1Val, handle2Val]);

				return;
			}

			if (elem.closest('.stepBtns--baggage')) {
				const stepBtns = elem.parentElement;

				if (!stepBtns.classList.contains('stepBtns--active')) {
					return;
				}

				const action = elem.dataset.action;
				const counter = stepBtns.querySelector('.stepBtns__counter');

				let value = parseInt(stepBtns.dataset.value, 10);

				if (action === 'plus') {
					if (value < 9) {
						value++;
					}
				} else {
					if (value === 0) {
						return;
					}

					value--;
				}

				stepBtns.dataset.value = value;
				counter.innerHTML = value;

				return;
			}

			if (elem.getAttribute('type') === 'checkbox') {
				if (elem.id === 'filter-airlines-toggle') {
					const checkboxes = qsa('#filter-airlines input[type=checkbox]', this.html);

					checkboxes.forEach(checkbox => checkbox.checked = elem.checked);
				}

				if (elem.id === 'filter-agencies-toggle') {
					const checkboxes = qsa('#filter-agencies-options input[type=checkbox]', this.html);

					checkboxes.forEach(checkbox => checkbox.checked = elem.checked);
				}

				if (elem.closest('#filter-alliances')) {
					const checkedAlliances = qsa('#filter-alliances input[type=checkbox]:checked', this.html);
					const airlineCheckboxes = qsa('#filter-airlines input[type=checkbox]', this.html);

					if (!checkedAlliances.length) {
						airlineCheckboxes.forEach(checkbox => checkbox.checked = true);
					} else {
						let enabledAirlines = [];

						airlineCheckboxes.forEach(checkbox => checkbox.checked = false);

						checkedAlliances.forEach((checkbox, index) => {
							const alliance = checkbox.value;

							enabledAirlines = enabledAirlines.concat(resultsRender.response.allianceToAirlines[alliance]);
						});

						airlineCheckboxes.forEach((checkbox) => {
							enabledAirlines.find((enabledAirline) => {
								if (enabledAirline === checkbox.value) {
									checkbox.checked = true;
								}
							});
						});
					}
				}

				if (elem.closest('#filter-airports-stops')) {
					const isToggleBtn = (elem.id === 'filter-transfer-toggle');
					const isCountry = (elem.dataset.type === 'country');
					const filterStops = gebi('filter-stops');
					const checkboxes = filterStops.getElementsByTagName('input');

					if (isToggleBtn) {
						for (let i = 0; i < checkboxes.length; i++) {
							checkboxes[i].checked = elem.checked;
						}
					} else if (isCountry) {
						const cityInputs = qsa('input[type="checkbox"]', elem.closest('li'));

						cityInputs.forEach(input => (input.checked = elem.checked));
					}
				}

				if (elem.classList.contains('toggle-checkboxes')) {
					const checked = elem.checked;
					const label = elem.parentElement;
					const checkboxes = label.parentElement.querySelectorAll('input[type=checkbox]');

					checkboxes.forEach(checkbox => checkbox.checked = checked);
				}

				if (elem.closest('#filters')) {
					this.update();
				}

				return;
			}

			if (elem.classList.contains('filtersView__head')) {
				const savedFilters = storedItemRead('savedFilters') || {};
				let views = [];

				savedFilters.collapsed = [];

				elem.parentElement.classList.toggle('filtersView--collapsed');

				views = qsa('.filtersView--collapsed', this.html);

				if (views.length) {
					views.forEach(section => savedFilters.collapsed.push(section.id));
				}

				storedItemCreate('savedFilters', savedFilters);

				return;
			}

			if (elem.closest('.filterInfo')) {
				const filterTooltip = elem.closest('.filterInfo').querySelector('.filterTooltip > div').innerHTML;
				toaster.newToast(filterTooltip, 'info', 'stays');
			}
		};

		this._events.onChange = (e) => {
			const elem = e.target;
			if (elem.id === 'filter-paymentmethod-select' || elem.name === 'stops') {
				trackEvent.triggerGAevent('filterByten', 'clicked');
				this.update();
			}

			if (elem.id === 'sort-emission') {
				const newSorting = (elem.checked) ? 'emission' : false;
				EventDispatcher.dispatch('updateResultsSorting', newSorting);
			}
		};


		this.addPaddingBottom = () => {
			if ((content.offsetHeight + content.getBoundingClientRect().top) + parseFloat(window.getComputedStyle(content).paddingBottom) > window.innerHeight) {
				content.style.paddingBottom = `${this.html.getBoundingClientRect().top}px`;
				scrollDownBtn.style.bottom = this.html.getBoundingClientRect().top + 'px';
			} else {
				content.style.paddingBottom = 0;
			}
		};

		this._events.onScroll = (e) => {
			if (scrollTimer) {
				cancelAnimationFrame(scrollTimer);
			}

			scrollTimer = requestAnimationFrame(() => {
				if (isMobileView()) {
					return;
				}

				scrollTop = content.scrollTop;
				if (scrollTop < 5) {
					this.hideScrollBtn(scrollUpBtn);
				} else {
					this.showScrollBtn(scrollUpBtn);
				}


				this.addPaddingBottom();

				if (scrollTop === content.scrollHeight - content.offsetHeight) {
					this.hideScrollBtn(scrollDownBtn);
				} else {
					this.showScrollBtn(scrollDownBtn);
				}
			});
		};


		this.mutationObserver = new MutationObserver(() => {
			this._events.onScroll();
			setTimeout(() => {
				this.addPaddingBottom();
			}, 250);
		});
		this.mutationObserver.observe(content, {
			subtree: true,
			attributes: true
		});

		this._events.onWindowResize = (e) => {
			this._events.onScroll();
			this.setFiltersHeight();
		};

		this.html.addEventListener('click', this._events.onClick);
		this.html.addEventListener('change', this._events.onChange);

		this.html.addEventListener('click', (event) => {
			// If we clicked on "activate your filters" do nothing
			if (event.target.closest('.filtersTop')) {
				return;
			}
			if (!Object.keys(this.get()).length) {
				storedItemDelete('savedFilters');
			}
		});

		content.addEventListener('scroll', this._events.onScroll);
		window.addEventListener('scroll', this._events.onScroll);


		// Initialize positions, trigger scroll event:
		this._events.onScroll();

		window.addEventListener('resize', this._events.onWindowResize);

		EventDispatcher.addEventListener('updateFiltersSorting', (sorting) => {
			const sortEmissionFilter = qs('#sort-emission', this.html);
			if (sortEmissionFilter.checked && (sorting !== 'emission')) {
				sortEmissionFilter.checked = false;
				this.update(false);
			} else if ((sorting === 'emission') && !sortEmissionFilter.checked) {
				sortEmissionFilter.checked = true;
				this.update(false);
			}
		});

		EventDispatcher.addEventListener('disableYouthFilter', () => {
			if (this._isYouthSearch) {
				this._isYouthSearch = false;
				// Hide youthTicket checkbox
				const youthFilterInput = qs('#show-youth-ticket', this.html);
				youthFilterInput.checked = false;
				youthFilterInput.closest('li').classList.add('disabledFilter');
			}
		});

		// this._events.onChange = e =>
		// {
		// 	const elem = e.target;
		// 	const elemID = elem.id;

		// 	TODO: future release...
		// 	if (elemID === 'show-baggage-included')
		// 	{
		// 		const baggageSection = filters.querySelector('#filtersBaggageInc');

		// 		if (elem.checked)
		// 		{
		// 			baggageSection.classList.add('filtersBaggageInc--visible');
		// 		}
		// 		else
		// 		{
		// 			baggageSection.classList.remove('filtersBaggageInc--visible');
		// 		}

		// 		return;
		// 	}

		// 	if (elemID === 'filtersBaggagePerPersonRadio' || elemID === 'filtersBaggageTotalRadio')
		// 	{
		// 		const stepBtns = filters.querySelectorAll('.stepBtns');

		// 		stepBtns.forEach(btn => btn.classList.remove('stepBtns--active'));

		// 		if (elemID === 'filtersBaggagePerPersonRadio')
		// 		{
		// 			stepBtns[0].classList.add('stepBtns--active');
		// 		}
		// 		else
		// 		{
		// 			stepBtns[1].classList.add('stepBtns--active');
		// 		}

		// 		return;
		// 	}
		// };
	}
}
